<template>
  <div id="order" class="column is-full">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li v-for="(routeBreadcrumb, index) in routeBreadcrumbs" :key="index"><a :href="routeBreadcrumb.path" @click="$router.push(routeBreadcrumb.path)">{{ routeBreadcrumb.name }}</a></li>
      </ul>
    </nav>
    <!-- <v-wait for="fetching data">
      <template slot="waiting">
        <b-loading :is-full-page="isFullPage" :active="true"></b-loading>
      </template> -->
    <div class="columns">
      <div class="column is-12">
        <div class="columns">
          <div class="column is-6">
            <b-field label="Purchase Order #" :type="getFieldTypesFromValidationPath('order.purchase_order_number')" :message="getFieldMessages('order.purchase_order_number')">
              <b-input type="text" name="purchase_order_number" id="purchase_order_number" placeholder="PO #" v-model.trim="$v.order.purchase_order_number.$model" :loading="$wait.any" @input.native="set" :disabled="! isEditable" v-tooltip.top="purchaseOrderNumberTooltipOptions"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Needed Date" :type="getFieldTypesForNeededDate()" :message="getFieldMessages('order.needed_date')">
              <b-datepicker ref="datepicker" name="needed_date" id="needed_date" placeholder="Needed Date..." icon="calendar-today" :value="($v.order.needed_date.$model) ? new Date($v.order.needed_date.$model) : $v.order.needed_date.$model" :date-formatter="neededDateDisplay" :min-date="minNeededDate" :max-date="maxNeededDate" :loading="$wait.any" @input="setNeededDate" :disabled="! isEditable" v-tooltip.top="neededDateTooltipOptions"></b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <b-field label="Billing Address" :type="getFieldTypesFromValidationPath('order.billing_address_id')" :message="getFieldMessages('order.billing_address_id')">
              <b-select name="billing_address_id" id="billing_address_id" placeholder="Select Billing Address..." v-model.trim="$v.order.billing_address_id.$model" class="is-fullwidth" :loading="$wait.any" @input.native="setBillingAddressId" :disabled="! isEditable" expanded v-tooltip.top="billingAddressTooltipOptions">
                <option v-for="address in billingAddresses" :value="address.id" :key="address.id">
                  {{ address.street_address }}
                  {{ address.street_address2 }}
                  {{ address.city }}, {{ address.state }} {{ address.postal_code }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Shipping Address" :type="getFieldTypesFromValidationPath('order.shipping_address_id')" :message="getFieldMessages('order.shipping_address_id')" class="is-full">
              <b-select name="shipping_address_id" id="shipping_address_id" placeholder="Select Shipping Address..." v-model.trim="$v.order.shipping_address_id.$model" class="is-fullwidth" :loading="$wait.any" @input.native="setShippingAddressId" :disabled="! isEditable" expanded v-tooltip.top="shippingAddressTooltipOptions">
                <template v-if="hasSubsidiaries">
                  <optgroup v-for="(addresses, subsidiary) in shippingAddresses" :key="subsidiary" :label="subsidiary">
                    <option v-for="address in addresses" :value="address.id" :key="address.id">
                      {{ address.street_address }}
                      {{ address.street_address2 }}
                      {{ address.city }}, {{ address.state }} {{ address.postal_code }}
                    </option>
                  </optgroup>
                </template>
                <template v-else>
                  <option v-for="address in shippingAddresses" :value="address.id" :key="address.id">
                    {{ address.street_address }}
                    {{ address.street_address2 }}
                    {{ address.city }}, {{ address.state }} {{ address.postal_code }}
                  </option>
                </template>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns is-vcentered is-size-6 pt-3">
          <div class="column is-2 has-text-centered has-text-weight-medium is-underlined">
            Item Code
          </div>
          <div class="column is-8 has-text-weight-medium is-underlined">
            Item Name
          </div>
          <!--
          <div class="column is-1 has-text-centered has-text-weight-medium is-underlined">
            Price
          </div>
          -->
          <div class="column is-2 has-text-centered has-text-weight-medium is-underlined">
            Qty
          </div>
          <!--
          <div class="column is-1 has-text-right has-text-weight-medium is-underlined">
            Subtotal
          </div>
          -->
        </div>
        <template v-if="$wait.is('fetching data')">
          <div v-for="n in 5" :key="n" class="columns is-vcentered is-size-6">
            <div class="column is-2">
              <b-skeleton width="100%" height="30px" class="py-5" :animated="true"></b-skeleton>
            </div>
            <div class="column is-8">
              <b-skeleton width="100%" height="30px" class="py-5" :animated="true"></b-skeleton>
            </div>
            <!--
            <div class="column is-1">
              <b-skeleton width="100%" height="30px" class="py-5" :animated="true"></b-skeleton>
            </div>
            -->
            <div class="column is-2">
              <b-skeleton width="100%" height="30px" class="py-5" :animated="true"></b-skeleton>
            </div>
            <!--
            <div class="column is-1">
              <b-skeleton width="100%" height="30px" class="py-5" :animated="true"></b-skeleton>
            </div>
            -->
          </div>
        </template>
        <order-item v-for="(orderItem, index) in order.orderItems" :key="orderItem.id" :index="index" :order-item="orderItem" :selected-item="getItemFromOrderItem(orderItem)"></order-item>
        <order-item v-if="isEditable"></order-item>
        <!--
          <template v-if="hasOrderItems">
            <div class="columns is-vcentered is-size-6">
              <div class="column is-11 has-text-right has-text-weight-bold">
                Item Subtotal ({{ order.item_count }})
              </div>
              <div class="column is-1 has-text-right is-tabular-numbers">
                {{ order.subtotal | currency }}
              </div>
            </div>
            <div class="columns is-vcentered is-size-6">
              <div class="column is-11 has-text-right has-text-weight-bold">
                Sales Tax
              </div>
              <div class="column is-1 has-text-right is-tabular-numbers">
                {{ order.sales_tax | currency }}
              </div>
            </div>
            <div class="columns is-vcentered is-size-6">
              <div class="column is-11 has-text-right has-text-weight-bold">
                Federal Excise Tax (FET)
              </div>
              <div class="column is-1 has-text-right is-tabular-numbers">
                {{ order.federal_excise_tax | currency }}
              </div>
            </div>
            <div class="columns is-vcentered is-size-6">
              <div class="column is-11 has-text-right has-text-weight-bold">
                Product Total:
              </div>
              <div class="column is-1 has-text-right has-text-weight-bold is-tabular-numbers">
                {{ order.total | currency }}
              </div>
            </div>
          </template>
          -->
        <nav class="level is-align-items-top py-3">
          <div class="level-item has-text-centered">
            <span v-tooltip.top="notesButtonTooltipOptions">
              <b-button type="is-primary" @click="displayNotesPrompt" :disabled="! isEditable"><i class="sl-note-paper-edit"></i> Notes</b-button>
            </span>
          </div>
          <div class="level-item has-text-centered">
            <div class="content">
              <span class="is-block" v-tooltip.top="saveDraftButtonTooltipOptions">
                <b-button type="is-primary" @click="saveDraft" :disabled="! isSavable" :class="{ 'is-loading-inline': $wait.is(['saving draft']) }">
                  <template v-if="isSaving">Saving...</template>
                  <template v-else-if="exists"><i class="sl-floppy-disk"></i> Save Draft Changes</template>
                  <template v-else><i class="sl-floppy-disk"></i> Save Draft</template>
                </b-button>
              </span>
              <p class="is-size-7 has-text-grey-light py-3">{{ lastSavedText }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <span v-tooltip.top="submitButtonTooltipOptions">
              <b-button type="is-primary" @click="submit" :loading="$wait.is(['submitting order'])" :disabled="! isSubmittable"><i class="sl-upload-2"></i> Submit Product Request</b-button>
            </span>
          </div>
          <div class="level-item has-text-centered">
            <span v-tooltip.top="cancelButtonTooltipOptions">
              <b-button type="is-danger" @click="cancel" :loading="$wait.is(['canceling order'])" :disabled="! isCancelable"><i class="sl-delete-1-1"></i> Cancel</b-button>
            </span>
          </div>

        </nav>
      </div>
    </div>
    <!-- </v-wait> -->
  </div>
</template>

<script>
import router from '@/router'
import store from '@/store'
import { dateShort, dateTimeShort, currency } from '@/filters'
import { required, minLength } from 'vuelidate/lib/validators'
import { validations, messages } from '@/plugins/vuelidate/validations/order'
import { dateShortFormat } from '@/plugins/moment'
import { proactiveDiscountPeriods, neededDatePeriodDays } from '@/config'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import moment from 'moment'
import uuid from 'uuid/v1'
import orderMixin from '@/mixins/order'

import OrderItem from '@/components/OrderItem'

export default {
  mixins: [
    orderMixin
  ],
  data () {
    return {
      originalOrder: {},
      proactiveDiscountPeriods,
      neededDatePeriodDays,
      messages: messages,
      apiValidationErrors: {},
      saveBeforeLeavingDialog: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'order',
      'customer',
      'items'
    ]),
    purchaseOrderNumberTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : 'Provide a PO # that will be retained on the product request once it is submitted'
      }
    },
    neededDateTooltipOptions () {
      let isFullDiscountEligible = this.isFullDiscountEligible(moment(this.order.needed_date), moment())
      return {
        trigger: 'hover',
        classes: [(this.order.needed_date) ? ((isFullDiscountEligible) ? 'is-success' : 'is-info') : ''],
        content: (this.isSubmitted) ? '' : ((this.order.needed_date) ? ((isFullDiscountEligible) ? 'This date is eligible for a full discount' : 'This date is not eligible for a full discount') : 'Provide a Needed Date that indicates when you would like to recieve the product')
      }
      // let isFullDiscountEligible = this.isFullDiscountEligible(moment(this.order.needed_date), moment())
      // return {
      //   trigger: 'hover',
      //   classes: [(this.order.needed_date) ? 'is-success' /* ((isFullDiscountEligible) ? 'is-success' : 'is-warning') */ : ''],
      //   content: (! this.order.needed_date || this.isSubmitted) ? '' : ((isFullDiscountEligible) ? 'This date is eligible for a full discount' : 'This date is not eligible for a full discount')
      // }
    },
    billingAddressTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : 'Select a Billing Address for the product request'
      }
    },
    shippingAddressTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : 'Select a Shipping Address for the product request'
      }
    },
    shippingTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : 'Your shipping amount will be calculated once the product request has been processed at Pneu-Dart'
      }
    },
    notesButtonTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : 'Add notes to this product request'
      }
    },
    saveDraftButtonTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : ((this.isSavable) ? `Save your changes to this product request` : `Once you've made changes to this product request, use this button to save them`)
      }
    },
    submitButtonTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isSubmitted) ? '' : ((this.isSubmittable) ? `Submit this product request to Pneu-Dart for processing` : ((this.isSavable) ? `You must save the changes to this product request before you can submit it to Pneu-Dart for processing` : `Once you've created a product request, use this button to submit it to Pneu-Dart for processing`))
      }
    },
    cancelButtonTooltipOptions () {
      return {
        trigger: 'hover',
        content: (this.isCancelable) ? `Cancel this product request` : ''
      }
    },
    saveDraftButtonText () {
      return (this.isSaving) ? `Saving...` : `<i class="sl-floppy-disk"></i> Save Draft${ (this.exists) ? ' Changes' : ''}`
    },
    lastSavedText () {
      return (! this.exists || this.isSaving) ? `` : `Last ${ moment(this.order.last_autosave_date).isSame(moment(this.order.update_date)) ? `Auto-` : `` }Saved: ${ this.$options.filters.dateTimeShort(this.order.last_autosave_date) }`
    },
    isFederalFirearmsLicenseRequired () {
      return this.order.orderItems.reduce((isFederalFirearmsLicenseRequired, orderItem) => {
        return isFederalFirearmsLicenseRequired || orderItem.is_federal_firearms_license_required
      }, false)
    },
    isDirty () {
      return ! isEqual(this.order, this.originalOrder)
    },
    isSaving () {
      return this.$wait.is(['saving draft'])
    },
    minNeededDate () {
      return (this.exists) ? moment(order.create_date).toDate() : new Date()
    },
    maxNeededDate () {
      let date = new Date()
      return new Date(date.setMonth(date.getMonth() + 12))
    },
    routeBreadcrumbs () {
      return [
        ...this.$route.meta.breadcrumbs,
        {
          name: (this.$wait.is('fetching data')) ? 'Loading...' : ((this.exists) ? `PO ${ this.originalOrder.purchase_order_number }` : 'New Product Request'),
          path: this.$route.path
        }
      ]
    },
    itemCount () {
      return this.orderItems.reduce((itemCount, orderItem) => {
        return itemCount + orderItem.quantity 
      }, 0)
    },
    hasSubsidiaries () {
      return this.user.subsidiaries && this.user.subsidiaries.length
    },
    billingAddresses () {
      return (this.customer.addresses) ? this.customer.addresses.filter((address) => address.address_type === 'BILLING' && (address.id === this.order.billing_address_id || address.is_active)) : []
    },
    shippingAddresses () {
      let shippingAddresses = {}
      if (this.hasSubsidiaries) {
        for (const subsidiary of this.user.subsidiaries) {
          let subsidiaryShippingAddresses = subsidiary.addresses.filter((address) => address.address_type === 'SHIPPING' && (address.id === this.order.shipping_address_id || address.is_active))
          if (subsidiaryShippingAddresses.length) {
            shippingAddresses[subsidiary.subsidiary_name] = subsidiaryShippingAddresses
          }
        }
        shippingAddresses = Object.keys(shippingAddresses).sort().reduce((carry, key) => {
          carry[key] = shippingAddresses[key]
            return carry;
          }, {})
        let otherShippingAddresses = this.customer.addresses.filter((address) => address.address_type === 'SHIPPING' && !address.subsidiary_id && (address.id === this.order.shipping_address_id || address.is_active))
        if (otherShippingAddresses.length) {
          shippingAddresses['Other'] = otherShippingAddresses
        }
      } else {
        shippingAddresses = this.customer.addresses.filter((address) => address.address_type === 'SHIPPING' && ! address.subsidiary_id && (address.id === this.order.shipping_address_id || address.is_active))
      }
      return shippingAddresses
    },
    // isShippingInternational () {
    //   return this.order.shippingAddress.country != 'US'
    // },
    hasErrors () {
      return this.$v.order.$error
    },
    // neededDate: function () {
    //   return new Date(this.$v.order.needed_date.$model)
    // }
    proactiveDiscountPeriodText () {
      return this.proactiveDiscountPeriods.map((period) => {
        const startDate = moment([moment().format('Y'), period.startMonth, period.startDay])
        const endDate = moment([moment().format('Y'), period.endMonth, period.endDay])
        return `${ startDate.format('M/D') } - ${ endDate.format('M/D') }`
      }).join(' and ')
    }
  },
  watch: {
    '$route': 'fetchData', // On route change, fetch data
  },
  methods: {
    ...mapActions([
      'getOrder',
      'createOrder',
      'updateOrder',
    ]),
    ...mapMutations({
      receiveGetOrder: 'RECEIVE_GET_ORDER',
      clearOrder: 'CLEAR_ORDER'
    }),
    async fetchData () {
      this.$wait.start('fetching data')
      if (this.$route.params.id) {
        try {
          await this.getOrder({
            'id': this.$route.params.id,
            includes: [
              'orderItems',
              'billingAddress',
              'shippingAddress',
            ]
          })
        } catch (error) {
          console.log(error)
        }
        if (this.isPublished) {
          this.$buefy.dialog.alert({
            'type': 'is-danger',
            'message': 'This product request has already been published and is unable to be edited.',
            'trap-focus': true,
            'onConfirm': () => {
              router.go(-1)
            }
          })
        }
      } else {
        this.receiveGetOrder(this.initOrder())
      }
      this.originalOrder = cloneDeep(this.order)
      this.$wait.end('fetching data')
    },
    failedApiValidation (property) {
      return this.apiValidationErrors.hasOwnProperty(property)
    },
    clearApiValidationFailures (property) {
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        delete this.apiValidationErrors[property]
      }
    },
    getFieldTypesFromValidationPath (validationPath) {
      return {
        'is-danger': eval(`this.$v.${ validationPath }.$error`)
      }
    },
    getFieldTypesForNeededDate () {
      let fieldTypes = this.getFieldTypesFromValidationPath('order.needed_date')
      if (this.order.needed_date) {
        let isFullDiscountEligible = this.isFullDiscountEligible(moment(this.order.needed_date), moment())
        fieldTypes['is-info'] = ! isFullDiscountEligible
        fieldTypes['is-success'] = isFullDiscountEligible
      }
      return fieldTypes
    },
    getFieldMessages(validationPath) {
      let validationPathArray = validationPath.split('.')
      return {...this.getFieldMessagesFromValidationPath(validationPath), ...this.getFieldMessagesFromFailedApiValidation(validationPathArray.pop())}
    },
    getFieldMessagesFromFailedApiValidation (property) {
      let fieldMessages = {}
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        fieldMessages[this.apiValidationErrors[property]] = true
      }
      return fieldMessages
    },
    getFieldMessagesFromValidationPath (validationPath) {
      let validationPathArray = validationPath.split('.')
      let messages = this.messages

      while (validationPathArray.length) {
        messages = messages[validationPathArray.shift()]
      }

      let fieldMessages = {}

      for (const validation in messages) {
        fieldMessages[messages[validation]] = eval(`this.$v.${ validationPath }.$error && ! this.$v.${ validationPath }.${ validation }`)
      }

      return fieldMessages
    },
    getAddressById (id) {
      return this.customer.addresses.find(function (address) {
        return address.id === id
      })
    },
    getItemFromOrderItem (orderItem) {
      return this.items.find(function (item) {
        return item.item_code === orderItem.item_code
      })
    },
    isFullDiscountEligible (neededDate, createDate) {
      return this.meetsNeededDatePeriod(neededDate, createDate) || this.isWithinProactiveDiscountPeriod(createDate);
    },
    meetsNeededDatePeriod (neededDate, createDate) {
      let differenceDays = 0
      if (neededDate.isSameOrAfter(createDate)) {
        differenceDays = Math.ceil(neededDate.diff(createDate, 'days', true))
      }
      // console.log('meetsNeededDatePeriod', neededDate.format(dateShortFormat), createDate.format(dateShortFormat), differenceDays, differenceDays >= this.neededDatePeriodDays)
      return differenceDays >= this.neededDatePeriodDays
    },
    getFullDiscountEligibleNeededDate(createDate) {
      return createDate.add(this.neededDatePeriodDays, 'days')
    },
    isWithinProactiveDiscountPeriod (date) {
      return this.proactiveDiscountPeriods.reduce(function (result, period) {
        const startDate = moment([moment().format('Y'), period.startMonth, period.startDay])
        const endDate = moment([moment().format('Y'), period.endMonth, period.endDay])
        // console.log('isWithinProactiveDiscountPeriod', date.format(dateShortFormat), startDate.format(dateShortFormat), endDate.format(dateShortFormat), date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate))
        return result || (date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate))
      }, false)
    },
    neededDateDisplay (d) {
      return this.$options.filters.dateShort(d)
    },
    setNeededDate (date) {
      this.clearApiValidationFailures('needed_date')
      // console.log(date)
      let neededDate = moment(date)
      let createDate = moment()
      // console.log(neededDate.format(moment.DATE), createDate.format(moment.DATE))
      if (! this.isFullDiscountEligible(neededDate, createDate)) {
        // this.$buefy.dialog.alert({
        //   type: 'is-warning',
        //   // hasIcon: true,
        //   // icon: 'exclamation-circle',
        //   // iconPack: 'fa',
        //   message: `<p><strong>The provided Needed Date does not qualify for a full discount.</strong></p><br><p>To qualify for a full discount, this product request must either be submitted during our proactive discount periods (${ this.proactiveDiscountPeriodText }) or it must have it's Needed Date set to at least ${this.neededDatePeriodDays} days from it's submission date.</p><br><p>Earliest Needed Date for Full Discount: <strong>${this.getFullDiscountEligibleNeededDate(createDate).format(dateShortFormat) }</strong>`
        // })
        this.$set(this.order, 'price_discount_level_id', this.customer.priceDiscountLevel.penalty_price_discount_level_id)
      } else {
        this.$set(this.order, 'price_discount_level_id', this.customer.priceDiscountLevel.id)
      }
      this.$set(this.order, 'needed_date', neededDate.format())
      this.reinitOrderItems()
      this.applyOrderCalculations()
    },
    setBillingAddressId (e) {
      this.clearApiValidationFailures(e.target.name)
      this.$set(this.order, e.target.name, e.target.value)
      this.$set(this.order, 'billingAddress', this.getAddressById(parseInt(e.target.value)))
      this.captureBillingAddress()
    },
    setShippingAddressId (e) {
      this.clearApiValidationFailures(e.target.name)
      this.$set(this.order, e.target.name, e.target.value)
      this.$set(this.order, 'shippingAddress', this.getAddressById(parseInt(e.target.value)))
      this.captureShippingAddress()
      this.reinitOrderItems()
      this.applyOrderCalculations()
    },
    set (e) {
      this.clearApiValidationFailures(e.target.name)
      this.$set(this.order, e.target.name, e.target.value)
    },
    isValid (autoSave = false) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (! autoSave) {
          this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Please fix the indicated fields'
          })
        }
        return
      }
      return true
    },
    async displayNotesPrompt () {
      let notes = this.order.notes
      const { result, dialog } = await this.$buefy.dialog.prompt({
        message: `Product Request Notes`,
        inputAttrs: {
          type: 'textarea',
          placeholder: 'Notes...',
          value: notes,
        },
        trapFocus: true
      })
      this.$set(this.order, 'notes', result)
    },
    async saveDraft (autoSave = false) {
      this.$wait.start('saving draft')
      if (this.isValid(autoSave)) {
        if (this.exists) {
          await this.update(autoSave)
        } else {
          await this.create(autoSave)
          router.replace({
                path: `/product-request/${ this.order.id }`
          })
        }
        if (! autoSave) {
          this.$buefy.toast.open({
            message: 'Your draft has been saved',
            type: 'is-success',
            position: 'is-top',
            duration: 5000,
          })
        }
      }
      this.$wait.end('saving draft')
    },
    async create (autoSave = false) {
      try {
        await this.createOrder({ 
          'data': this.order,
          'includes': [
            'orderItems'
          ] 
        })
        this.originalOrder = cloneDeep(this.order)
        history.replaceState({}, '', `/product-request/${ this.order.id }`)
      } catch (error) {
        console.log(error)
        switch (error.response.status) {
          case 422:
            this.apiValidationErrors = error.response.data.errors
            this.isValid(autoSave)
            break
        }
        return Promise.reject(error)
      }
    },
    async update (autoSave = false) {
      try {
        await this.updateOrder({ 
          'id': this.order.id, 
          'data': this.order,
          'includes': [
            'billingAddress',
            'shippingAddress',
            'orderItems'
          ] 
        })
        this.originalOrder = cloneDeep(this.order)
        this.$v.$reset()
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.apiValidationErrors = error.response.data.errors
            this.isValid(autoSave)
            break
          default:
            console.log(error)
        }
        return Promise.reject(error)
      }

    },
    async submit () {
      this.$wait.start('submitting order')
      let neededDate = moment(this.order.needed_date)
      let date = moment()
      if (! this.isFullDiscountEligible(neededDate, date)) {
        let neededDateConfirmed = await new Promise((resolve) => {
          let createDate = moment()
          this.$buefy.dialog.confirm({
            // type: 'is-warning',
            // hasIcon: true,
            // icon: 'exclamation-circle',
            // iconPack: 'fa',
            message: `<p>The provided Needed Date does not qualify for a full discount.</p><br><p>To qualify for a full discount, this product request must either be submitted during our proactive discount periods (${this.proactiveDiscountPeriodText}) or it must have it's Needed Date set to at least ${this.neededDatePeriodDays} days from it's submission date.</p><br><p>Earliest Needed Date for Full Discount: <strong>${this.getFullDiscountEligibleNeededDate(createDate).format(dateShortFormat)}</strong>`,
            cancelText: 'Adjust Needed Date',
            confirmText: 'Accept Needed Date and Submit',
            onCancel: () => resolve(false),
            onConfirm: () => resolve(true)
          })
        })
        if (! neededDateConfirmed) {
          this.$wait.end('submitting order')
          return
        }
      }
      await new Promise((resolve) => {
        this.$buefy.dialog.alert({
          message: ((this.isFederalFirearmsLicenseRequired) ? `<p>The contents of this product request require a Federal Firearms License. If you haven't provided a Federal Firearms License to us already, please email the license information to <a href="mailto:channelpartnerrequests@pneudart.com?subject=Federal Firearms License (${ this.order.purchase_order_number })">channelpartnerorder@pneudart.com</a> at your earliest convenience.</p><br>` : ``) + `<p>If this product request is high priority, please contact us immediately at <a href="mailto:channelpartnerorder@pneudart.com?subject=High Priority Product Request (${ this.order.purchase_order_number })">channelpartnerorder@pneudart.com</a>.</p>`,
          onConfirm: () => resolve(true)
        })
      })
      this.$set(this.order, 'status', 'PENDING_IMPORT')
      await this.update()
      this.$wait.end('submitting order')
      this.$buefy.toast.open({
        message: 'Your product request has been submitted. Thank you!',
        type: 'is-success',
        position: 'is-top',
        duration: 5000,
      })
    },
    async cancel () {
      this.$wait.start('canceling order')
      let confirmed = await new Promise((resolve) => {
        this.$buefy.dialog.confirm({
          type: 'is-danger',
          // hasIcon: true,
          // icon: 'exclamation-circle',
          // iconPack: 'fa',
          message: `<p>Are you sure you want to cancel this product request?</p>`,
          onCancel: () => resolve(false),
          onConfirm: () => resolve(true)
        })
      })
      if (! confirmed) {
        this.$wait.end('canceling order')
        return
      }
      this.$set(this.order, 'status', 'CANCELED')
      await this.update()
      this.$wait.end('canceling order')
      this.$buefy.toast.open({
        message: 'Your product request has been canceled',
        type: 'is-success',
        position: 'is-top',
        duration: 5000,
      })
    }
  },
  filters: {
    dateShort,
    dateTimeShort,
    currency
  },
  validations: validations,
  components: {
    OrderItem
  },
  async created () {
    await this.fetchData()
  },
  mounted () {
    this.$nextTick(function () {
      this.$v.$reset()
    })
  },
  onIdle () {
    if (this.isDirty && this.isDraft) { // Auto-save order
      this.$set(this.order, 'last_autosave_date', moment.utc().format())
      this.saveDraft(true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDirty) {
      let self = this
      this.saveBeforeLeavingDialog = this.$buefy.dialog.confirm({
        // 'type': 'is-danger',
        // 'title': 'Save Changes?',
        'message': 'This draft has been modified but it has not been saved. Would you like to save your changes before leaving?',
        'confirmText': 'Save Changes and Leave',
        'cancelText': 'Leave without Saving',
        'trap-focus': true,
        'onConfirm': async function () {
          console.log(this)
          await self.update()
          self.clearOrder() // Remove it from state since we're done working with the order
          next()
        },
        'onCancel': function () {
          self.clearOrder() // Remove it from state since we're done working with the order
          next()
        }
      })
    } else {
      this.clearOrder() // Remove it from state since we're done working with the order
      next()
    }
  }
}
</script>
